module.exports = __webpack_public_path__ + "static/media/Large-01MA030K20DTS_CMJN__.3ae22334.png";